import { createPortal } from 'react-dom'
import ReactHlsPlayer from 'react-player/file'

import { Icon } from '../Icon'
import Button from './design/Button'

type Props = ({ url: string; title: string } | { hlsUrl: string }) & {
    isOpen: boolean
    description?: string
    onClose: () => void
    onEnded?: () => void
}

export function FullScreenVideoModal({ isOpen, description, onClose, onEnded, ...props }: Props) {
    if (!isOpen) return null

    return createPortal(
        <div
            className="fixed inset-0 flex h-screen w-full flex-col bg-gray-700"
            data-testid="page-container"
            {...props}
        >
            <div className="absolute top-0 right-0 z-10 m-4 flex justify-end">
                <Button
                    intent="tertiary_deprecated"
                    onClick={onClose}
                    className="size-12 hover:bg-gray-600"
                    size="small"
                >
                    <Icon icon="close.large" shouldInheritColor className="text-white" />
                </Button>
            </div>
            {description && (
                <div className="flex w-full items-center justify-center">
                    <div className="max-w-[580px] pt-14 pb-8 text-center text-gray-400">
                        {description}
                    </div>
                </div>
            )}

            <div className="flex flex-grow justify-center px-8">
                {'url' in props && (
                    <iframe
                        title={props.title}
                        src={props.url}
                        width="100%"
                        height="100%"
                        allow="fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                )}
                {'hlsUrl' in props && (
                    <ReactHlsPlayer
                        url={props.hlsUrl}
                        width="auto"
                        height={'100vh'}
                        controls={true}
                        autoPlay={true}
                        onEnded={onEnded}
                    />
                )}
            </div>
        </div>,
        document.body
    )
}
